import React from 'react';

// import GeneralSetting from '../Drive/GeneralSetting'
// import AccountPreference from '../Drive/AccountPreference/index'
// import CommonSettings from '../Drive/CommonSettings'

export default class SettingList extends React.Component {
    render() {
        return (
            <div className="general-setting" >
                {/* <GeneralSetting {...this.props} /><br /> */}
                {/* <AccountPreference {...this.props} /><br />
                <CommonSettings {...this.props} /><br /> */}
            </div>
        );
    }
}
